export default __webpack_public_path__ + "static/media/room-propolis-2.402c1487.jpg";